import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app/App";
import { IS_DUKAANBOOK } from "./brand";
import { applyScheme, savedScheme } from "./theme/provider";
import "./styles/theme.css";

/**
 * DukaanBook (`pnpm dukaan:web`) is this same app with the shop's colour,
 * words and pages (DukaanBook-Design.docx, section 2.3); FarmashiBook
 * otherwise, unchanged. The colour follows `data-app` (styles/theme.css), so
 * it is set before anything is drawn.
 */
if (IS_DUKAANBOOK) {
  document.documentElement.dataset.app = "dukaanbook";
  document.title = "DukaanBook";
}

// Before React draws anything: a dark-mode person never sees a white flash.
applyScheme(savedScheme());

const root = document.getElementById("root");
if (!root) throw new Error("index.html has no #root");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
